import React from 'react';
import { Helmet } from 'react-helmet';

const MetaTags = ({ title, description, keywords, slug, alt }) => {
  const baseUrl =
    typeof window !== "undefined" ? window.location.origin : "";

  const canonicalUrl = `${baseUrl}/${slug}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* ✅ Canonical */}
      <link rel="canonical" href={canonicalUrl} />
      <meta name="robots" content="index,follow" />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
    </Helmet>
  );
};

export default MetaTags;
